// src/utils/toast.js

import { toast, ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

// Success toast
const handleSuccess = info => {
  toast.success(info, {
    position: 'top-right',
    autoClose: 5000,
    hideProgressBar: false,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: true,
    progress: undefined,
    theme: 'light',
  });
};

// Error toast
const handleError = info => {
  toast.error(info, {
    position: 'top-right',
    autoClose: 5000,
    theme: 'light',
  });
};

export { handleSuccess, handleError, ToastContainer };
